<template>
	<Tag :color="color">{{ $t('gpsFixQuality.' + quality) }} </Tag>
</template>
<script>
import { toRef, computed } from 'vue';
import { Tag } from 'ant-design-vue';

import MapHelpers from '@/components/map/utils/MapHelpers';

export default {
	components: {
		Tag,
	},
	props: {
		quality: {
			type: Number,
			required: false,
			default: 0,
		},
	},
	setup(props) {
		const qualityRef = toRef(props, 'quality');
		const color = computed(() => '#' + MapHelpers.getGnssFixQualityDisplay(qualityRef.value).color);
		return {
			color,
		};
	},
}
</script>
